import { render, staticRenderFns } from "./SecondaryFooter.vue?vue&type=template&id=5d00f905&"
import script from "./SecondaryFooter.vue?vue&type=script&lang=js&"
export * from "./SecondaryFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports